var map = {
	"./blog_ss.png": "c39f",
	"./cic.png": "ad51",
	"./github.png": "359c",
	"./ihr_ss.png": "0175",
	"./life-game-screenshot.png": "a106",
	"./mountains.jpg": "248a",
	"./tc-ss.png": "c722",
	"./texture.jpg": "8acf",
	"./texture_header.jpg": "3e8c",
	"./tracking_ss.png": "e63f",
	"./trees.jpg": "de48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";